export default __webpack_public_path__ + "static/media/dealCards.a753dc78.mp3";